import { render } from "./App.vue?vue&type=template&id=fca4c540"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fca4c540&lang=css"

import exportComponent from "/Users/kaho/cloudfit-pro-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__